import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs/Rx";
import { StateLicensedInReportView } from './statelicensedinreport.model';

@Injectable()
export class StateLicensedInReportService {
    public reportList: StateLicensedInReportView[] = [];

    constructor(private http: HttpClient) { }

    getStateLicensedInReportList(): Observable<StateLicensedInReportView[]> {
        return this.http.get(
            `api/recruits/getstatelicensedinmpmdbypage?pagenumber=1&pagesize=10000&search=undefined`,
            { observe: 'response' }
        ).map((response: any) => {
            this.reportList = response.body;
            return this.reportList;
        });
    }
}
